// TODO: implement
export const PageFooter = () => {
  return null;
};
